app = angular.module('harriApp');

app.directive('searchCandidateCard', ["amsApi", "harriSort", "$timeout", "amsMoveHandler", "amsDOMHelper", "amsCards", "$rootScope", "$filter", function (amsApi, harriSort, $timeout, amsMoveHandler, amsDOMHelper, amsCards, $rootScope, $filter) {
  return {
    templateUrl: "../modules/candidate_card/views/search_candidate_card.html",
    restrict: 'E',
    transclude: true,
    replace: true,
    link: {
      pre: function (scope, elem, attr) {
      }
    }
  }
}]);
